export enum Environment {
  Debug = 'debug',
  Production = 'production',
  QA = 'qa',
  Sandbox = 'sandbox',
  Services = 'services',
  Staging = 'staging'
}
